import React from 'react'
import Form from './Form'

function Contact() {
  return <section id='contact' className='section'>
    <section className='sub-section'>
      <h2 className='title'>CONTACT</h2>
        <Form />
    </section>
  </section>
}

export default Contact